module.exports = new __parcel__URL__("html5-without-wordmark-color-seeklogo.96e035ca.svg").toString();